import {Component} from '@angular/core';
import {UtilsService} from '../../core/utils/utils.service';
import {Router} from "@angular/router";

@Component({
  selector: 'yo-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: [
    '../gestion-stocks-root.component.scss',
    './stocks.component.scss'
  ],
  standalone: false
})
export class StocksComponent {

  constructor(public utils: UtilsService,
              private readonly router: Router) {
  }

  disableSearch(): boolean {
    return this.router.url.includes('stock-minimum');
  }

}
